import BackgroundCheckSecurityFreezeAlert from './BackgroundCheckSecurityFreezeAlert';
export default BackgroundCheckSecurityFreezeAlert;
